module.exports = __webpack_public_path__ + "img/_circle-blue1.f38fe82c.svg";